import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { HTML } from '@xsite-ui/common.html';
import React, { useState } from 'react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from '@emotion/styled';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var minDesktopWidth = '800px';
var Button = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return props !== null && props !== void 0 && props.isDisclosureInFooter ? "  font-weight: 700;\n  margin: 0 0 36px;\n  text-align: left;\n  font-size: inherit;\n  line-height: inherit;\n  background-color: inherit;\n  color: inherit;\n  border: none;\n  cursor: pointer;\n  transition: 0.3s ease-in-out;\n  white-space: nowrap;\n  :hover {\n    opacity: 80%;\n  }" : "  font-size: 14px;\n  letter-spacing: -0.37px;\n  background-color: transparent;\n  text-decoration: underline;\n  cursor: pointer;\n  width: max-content;\n  color: #000000;\n  ";
});
var PopUpContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 999;\n  background-color: rgba(255, 255, 255, 0.95);\n  line-height: 17px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 0 10px rgb(0 0 0 / 15%);\n  border: 1px solid #d6d6d6;\n  transition: 0.1s ease-in-out;\n  top: ", ";\n  bottom: ", ";\n  margin-right: 15px;\n  width: 80vw;\n\n  @media (min-width: ", ") {\n    width: 367px;\n    margin: 0;\n  }\n"])), function (_ref) {
  var position = _ref.position;
  return position === 'down' && '25px';
}, function (_ref2) {
  var position = _ref2.position;
  return position === 'up' && '100%';
}, minDesktopWidth);
var Content = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  background-color: #fff;\n  color: #171717;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: -0.2px;\n  text-align: left;\n"])));
var CloseButton = styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  color: #1564bf;\n  cursor: pointer;\n  font-size: 15px;\n  border: none;\n  background-color: transparent;\n  margin-top: 20px;\n  text-decoration: none;\n"])));
var Container = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n"])));

var AdvertisingDisclosure = function AdvertisingDisclosure(_ref) {
  var title = _ref.title,
      text = _ref.text,
      isDisclosureInFooter = _ref.isDisclosureInFooter,
      _ref$closeButtonText = _ref.closeButtonText,
      closeButtonText = _ref$closeButtonText === void 0 ? 'Close' : _ref$closeButtonText,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'up' : _ref$position;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handleToggle = function handleToggle() {
    return setIsOpen(!isOpen);
  };

  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "advertising-disclosure"
  }, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "opening-label",
    "data-hook": "open-advertising-disclosure",
    isDisclosureInFooter: isDisclosureInFooter,
    onClick: handleToggle
  }, title), isOpen && /*#__PURE__*/React.createElement(PopUpContainer, {
    position: position
  }, /*#__PURE__*/React.createElement(Content, {
    "data-testid": "popup"
  }, /*#__PURE__*/React.createElement(HTML, {
    testId: "text"
  }, text), /*#__PURE__*/React.createElement(CloseButton, {
    onClick: handleToggle,
    "data-testid": "close-button"
  }, closeButtonText))));
};

export { AdvertisingDisclosure };
